import React, { Component, Fragment, useState } from "react";
import { withStyles } from "@mui/styles";
import CustomizedSnackbar from "../../../../../components/CustomizedSnackbar/CustomizedSnackbar";
import LoginMenu from "../../../../../components/LoginMenu/LoginMenu";
import {Divider, IconButton, Tooltip, CircularProgress, Grid, Typography, Button,
  Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper} from "@mui/material";
  import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { format } from "date-fns";
import FilterIcon from "@mui/icons-material/FilterList";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import F300FormFilter from "./F300FormFilter";
import F300FormTable from "./F300FormTable";
import { useDropzone } from "react-dropzone";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "rgb(29, 95, 152)", //theme.palette.common.black,
    color: theme.palette.common.white,
    fontWeight: 500,
    border: '1px solid white'
  },
  body: {
    fontSize: 14,
    border: '1px solid rgb(29, 95, 152)'
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const styles = ({
  table: {
    width: "100%",
  },
});

function HelpingMaterialPopup (props) {

  const {classes, open, handleClose, filesName=[]} = props;

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  console.log("props", props);

  return (
    <Dialog
      maxWidth="md"
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
    >
      <span style={{ color: "#ffffff" }}>
       _______________________________________________________________________________________________________________________
      </span>
      <DialogTitle style={{ paddingBottom: 0 }} id="responsive-dialog-title">
        <IconButton
          aria-label="close"
          onClick={handleClose}
          style={{
            position: "relative",
            top: "-35px",
            right: "-24px",
            float: "right",
          }}
          size="large">
          <CloseOutlinedIcon color="secondary" />
        </IconButton>
        <Typography
          style={{
            color: "#1d5f98",
            fontWeight: 600,
            borderBottom: "1px solid rgb(58, 127, 187, 0.3)",
            fontSize: 20,
          }}
        >
          Assignment Helping Material
        </Typography>      
      </DialogTitle>
      <DialogContent>
        <Grid
          container
          direction="row"
          alignItems="center"
          spacing={2}
          style={{
            marginTop: -10,
          }}
        >
          <Grid size={12}>
          <TableContainer component={Paper}>
          <Table className={classes.table} size="small" aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell style={{borderLeft: '1px solid rgb(29, 95, 152)'}}>File&nbsp;Name</StyledTableCell>
                <StyledTableCell align="center">Download</StyledTableCell>
                <StyledTableCell align="center" style={{borderRight: '1px solid rgb(29, 95, 152)'}}>View</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {filesName.length > 0
              ? filesName.map((dt, i) => (
                <StyledTableRow key={dt+i}>
                   <StyledTableCell component="th" scope="row">{dt}</StyledTableCell>
                    <StyledTableCell align="center">
                      <Tooltip title="Download">
                        <IconButton
                          onClick={(e)=>props.downloadFile(e, dt)}
                          aria-label="download"
                          size="large">
                          <CloudDownloadIcon color="primary" />
                        </IconButton>
                      </Tooltip>
                    </StyledTableCell>
                   <StyledTableCell align="center">
                   <Tooltip title="Download">
                      <IconButton
                        onClick={(e)=>props.downloadFile(e, dt, true)}
                        aria-label="download"
                        size="large">
                        <VisibilityOutlinedIcon color="primary" />
                      </IconButton>
                    </Tooltip>
                   </StyledTableCell>
                </StyledTableRow>
              ))
              :
              <StyledTableRow key={1}>
                <StyledTableCell component="th" scope="row" colSpan={6}><center><b>No Data</b></center></StyledTableCell>
              </StyledTableRow>
            }
            </TableBody>
          </Table>
        </TableContainer>
        </Grid>
        </Grid>
      </DialogContent>
      <Divider
        style={{
          backgroundColor: "rgb(58, 127, 187)",
          opacity: "0.3",
        }}
      />
      <DialogActions>
        <Button autoFocus onClick={handleClose} color="secondary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function MyDropzone(props) {

  const [isFileSelected, setIsFileSelected] = useState(false);
 
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({ accept: 'application/pdf, text/plain, application/vnd.oasis.opendocument.text, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document', multiple:false });

  const files = acceptedFiles.map((file, index) => {
    const size = file.size > 0 ? (file.size / 1000).toFixed(2) : file.size;
    if(!isFileSelected){ 
      setIsFileSelected(true);
      setTimeout(()=>{
        props.onFormSubmit("form"+props.index);
      }, 250);
    }
    return (
        <Typography key={index} variant="subtitle1" color="primary">
            {/* {file.path} - {size} Kb */}
            <input type="hidden" name="file_name" value={file.path}></input>
        </Typography>
    );
  });

  let msg = files || [];
  if(msg.length<=0) {
      //msg = <Typography variant="subtitle1">Please click here to  select and upload an file</Typography>;
      msg = (
              (<Button 
                variant="outlined" 
                color="primary" 
                size="small"
              >Submit
                              </Button>)
            // <Tooltip title="Upload">
            //   <IconButton  
            //     aria-label="Upload"
            //   >
            //     <CloudUploadOutlinedIcon color="primary"/>
            //   </IconButton>
            // </Tooltip>
      );
  }
  
  return (
      <Fragment>
        {isFileSelected && <Fragment><CircularProgress size={24} /></Fragment>}
        <form id={"form"+props.index} hidden={isFileSelected} style={{display:"inline-block"}}>
          <div
            style={{ textAlign: "center"}}
            {...getRootProps({ className: "dropzone", onChange: event => props.onChange(event) })}
          >
            <input name="assignmentId" type="hidden" value={props.assignmentId} />
            <input name="sectionId" type="hidden" value={props.sectionId} />
            <input name="contained-button-file" {...getInputProps()} disabled={props.disabled} />
            {msg}
          </div>
        </form>
      </Fragment>
  );
}

class F300Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      showTableFilter: false,
      showSearchBar: false,
      isDownloadExcel: false,
      applicationStatusId: 1,
      admissionData: null,
      genderData: [],
      degreeData: [],
      studentName: "",
      genderId: 0,
      degreeId: 0,
      applicationId: "",
      isLoginMenu: false,
      isReload: false,
      eventDate: null,
      isOpenSnackbar: false,
      snackbarMessage: "",
      snackbarSeverity: "",
      files: [],
      uploadLoading:false,
      popupBoxOpen: false,
      popupBoxFiles: [],
    };
  }

  handleOpenSnackbar = (msg, severity) => {
    this.setState({
      isOpenSnackbar: true,
      snackbarMessage: msg,
      snackbarSeverity: severity,
    });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      isOpenSnackbar: false,
    });
  };

  handleFileChange = event => {
    const { files = [] } = event.target;
    if (files.length==1) {
        if ( (files[0].type === "application/pdf" || files[0].type === "text/plain" || files[0].type === "application/vnd.oasis.opendocument.text" || files[0].type === "application/msword" || files[0].type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") && files[0].size/1000<10000) {
            this.setState({
                files,
                filesError: ""
            });
        }else {
            this.handleOpenSnackbar("Please select only pdf, txt, odt, doc or docx file with size less than 10 MBs.","error");
        }
    } else {
      this.handleOpenSnackbar("Please select only one file at a time.","error");
    }
  }

  onClearFilters = () => {
    this.setState({
      studentName: "",
      genderId: 0,
      degreeId: 0,
      applicationId: "",
      eventDate: null,
    });
  };

  handleDateChange = (date) => {
    this.setState({eventDate: date});
  };

  getData = async (status) => {
    this.setState({isLoading: true});
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C300CommonAcademicsAssignmentsView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({Authorization: "Bearer "+localStorage.getItem("lmsToken")}),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            for (var i = 0; i < json.DATA.length; i++) {
              let sectionId = json.DATA[i].sectionId;
              let assignmentId = json.DATA[i].id;
              let studentAssignmentFileName = json.DATA[i].studentAssignmentFileName;
              let isValidDueDate = json.DATA[i].isValidDueDate;
              let isValidDownloadAssignment = json.DATA[i].isValidDownloadAssignment;
              let fileName = json.DATA[i].fileName;
              json.DATA[i].fileDownload = (
                <Fragment>
                  {/* <Tooltip title="Download">
                    <IconButton 
                      onClick={(e)=>this.downloadFile(e, fileName)} 
                      aria-label="download"
                    >
                      <CloudDownloadIcon color="primary" />
                    </IconButton>
                    </Tooltip> */}

                    {isValidDownloadAssignment==1 ? 
                   
                        <Tooltip title="Download">
                          <IconButton
                            onClick={(e)=>this.downloadFile(e, fileName)}
                            aria-label="download"
                            size="large">
                            <CloudDownloadIcon color="primary" />
                          </IconButton>
                        </Tooltip>
                    :
                    <IconButton disabled={true} aria-label="download" size="large">
                    <CloudDownloadIcon />
                  </IconButton>
                  }

                </Fragment>

                
              );

              let solutionFileName = json.DATA[i].solutionFileName;
              json.DATA[i].solutionFileDownload = (
                solutionFileName ?   
                  <Tooltip title="Download">
                    <IconButton
                      onClick={(e)=>this.downloadFile(e, solutionFileName)}
                      aria-label="download"
                      size="large">
                      <CloudDownloadIcon style={{color:"#4caf50"}} />
                    </IconButton>
                  </Tooltip>
                  :
                  ""
              );

              json.DATA[i].answerSheet = (
                <Fragment>
                  {isValidDueDate==1 ?
                      <MyDropzone
                        index={i}
                        files={this.state.files} 
                        onChange={event => this.handleFileChange(event)} 
                        disabled={this.state.uploadLoading}
                        onFormSubmit={this.onFormSubmit}
                        sectionId={sectionId}
                        assignmentId={assignmentId}
                      />
                    :
                    <Fragment>
                      <Button 
                        variant="outlined" 
                        size="small"
                        disabled={true}
                      >
                        Submit
                      </Button>
                    </Fragment>
                  }
                </Fragment>
              );
              
              json.DATA[i].answerSheetDownload = (
                studentAssignmentFileName ? 
                  <Tooltip title="Download">
                    <IconButton
                      onClick={(e)=>this.downloadFile(e, studentAssignmentFileName)}
                      aria-label="download"
                      size="large">
                      <CloudDownloadIcon style={{color:"#4caf50"}} />
                    </IconButton>
                  </Tooltip> 
                  // <Button 
                  //   variant="outlined" 
                  //   style={{
                  //     color:"#4caf50",
                  //     borderColor:"#4caf50",
                  //     marginTop: 8,
                  //     marginLeft: 2
                  //   }}
                  //   size="small"
                  //   onClick={(e)=>this.downloadFile(e, studentAssignmentFileName)} 
                  // >
                  //   Download
                  // </Button>
                :
                ""
              );

              let gradedAssignmentUrl = json.DATA[i].gradedAssignmentUrl;
              json.DATA[i].gradedAssignmentUrl = (
                gradedAssignmentUrl ? 
                <Fragment>
                  <Tooltip title="Download">
                    <IconButton
                      onClick={(e)=>this.downloadFile(e, gradedAssignmentUrl)}
                      aria-label="download"
                      size="large">
                      <CloudDownloadIcon color="primary" />
                    </IconButton>
                    </Tooltip>
                </Fragment>
                :
                ""
              );

              let helpingMaterialFileDownload = json.DATA[i].helpingMaterialFileNameArray || [];
              json.DATA[i].helpingMaterialFileDownload = (
                <Button 
                  variant="outlined" 
                  size="small"
                  color="primary"
                  disabled={!helpingMaterialFileDownload>0}
                  onClick={()=>this.handleClickOpen(helpingMaterialFileDownload)}
                >
                  Open
                </Button>
              );

            }
            this.setState({admissionData: json.DATA || []});
          } else {
            //alert(json.SYSTEM_MESSAGE + '\n' + json.USER_MESSAGE);
            this.handleOpenSnackbar(<span>{json.SYSTEM_MESSAGE}<br/>{json.USER_MESSAGE}</span>,"error");
          }
          console.log("getData", json);
        },
        (error) => {
          if (error.status === 401) {
            this.setState({
              isLoginMenu: true,
              isReload: false,
            });
          } else {
            //alert('Failed to fetch, Please try again later.');
            this.handleOpenSnackbar("Failed to fetch, Please try again later.","error");
            console.log(error);
          }
        }
      );
    this.setState({isLoading: false});
  };

  downloadFile = (e, fileName, viewOnly=false) => {
      e.preventDefault();
      const data = new FormData();
      data.append("fileName", fileName);
      const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/CommonViewFile?fileName=${encodeURIComponent(fileName)}`;
      fetch(url, {
          method: "GET",
          headers: new Headers({
              Authorization: "Bearer "+localStorage.getItem("lmsToken"),
          }),
      })
          .then((res) => {
              if (res.status === 200) {
                  return res.blob();
              } else if (res.status === 401) {
                  this.setState({
                      isLoginMenu: true,
                      isReload: false
                  })
                  return {}
              } else {
                  alert('Operation Failed, Please try again later.');
                  return {}
              }
          })
          .then((result) => {
              if(viewOnly) {
                let fileExtension = fileName.slice((Math.max(0, fileName.lastIndexOf(".")) || Infinity) + 1);
                let fileMimeType = result.type;
                if(fileExtension==="doc" || fileExtension==="DOC"){
                  fileMimeType = "application/msword";
                }else if(fileExtension==="pdf" || fileExtension==="PDF") {
                  fileMimeType = "application/pdf"
                }else if(fileExtension==="docx" || fileExtension==="DOCX"){
                  fileMimeType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
                }
                let blob = new Blob([result], { type: fileMimeType });
                if (blob) {
                    let fileURL = window.URL.createObjectURL(blob);
                    window.open(fileURL);
                }
              } else {
                let csvURL = window.URL.createObjectURL(result);
                let tempLink = document.createElement("a");
                tempLink.href = csvURL;
                tempLink.setAttribute("download", fileName);
                tempLink.click();
              }
              
              if (result.CODE === 1) {
                  //Code
              } else if (result.CODE === 2) {
                  alert("SQL Error (" +result.CODE +"): " +result.USER_MESSAGE +"\n" +result.SYSTEM_MESSAGE);
              } else if (result.CODE === 3) {
                  alert("Other Error ("+result.CODE+"): " +result.USER_MESSAGE +"\n" +result.SYSTEM_MESSAGE);
              } else if (result.error === 1) {
                  alert(result.error_message);
              } else if (result.success === 0 && result.redirect_url !== "") {
                  window.location = result.redirect_url;
              }
          })
          .catch((error) => {
              console.log(error);
          });
  };

  onFormSubmit = async (formId) => {
    if ( !this.isFileValid() ) { return; }
    let myForm = document.getElementById(formId);
    const data = new FormData(myForm);
    this.setState({ isLoading: true });
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C107CommonAcademicsAssignmentsStudentsSave`;
    await fetch(url, {
      method: "POST",
      body: data,
      headers: new Headers({Authorization:"Bearer "+localStorage.getItem("lmsToken")}),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            this.handleOpenSnackbar(json.USER_MESSAGE, "success");
            setTimeout(() => {
                window.location.reload();
            }, 1000);
          } else {
            this.handleOpenSnackbar(<span>{json.SYSTEM_MESSAGE}+<br/>+{json.USER_MESSAGE}</span>,"error");
          }
          console.log(json);
        },
        (error) => {
          if (error.status == 401) {
            this.setState({
              isLoginMenu: true,
              isReload: true,
            });
          } else {
            console.log(error);
            this.handleOpenSnackbar("Failed to Save ! Please try Again later.","error");
          }
        }
      );
    this.setState({ isLoading: false });
  };

  onHandleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  handleToggleTableFilter = () => {
    this.setState({ showTableFilter: !this.state.showTableFilter });
  };

  handleToggleSearchBar = () => {
    this.setState({ showSearchBar: !this.state.showSearchBar });
  };

  isFileValid = () => {
    let isValid = true;
    if (this.state.files.length<1 && this.state.recordId==0) {
      this.handleOpenSnackbar("Please select file.","error");
      isValid = false;
    } else {
      this.setState({ filesError: "" });
    }
    return isValid;
  };

  handleClickOpen = (popupBoxFiles) => {
    this.setState({ 
      popupBoxOpen: true,
      popupBoxFiles: popupBoxFiles
    });
  }

  handleClose = () => {
    this.setState({
      popupBoxOpen: false,
      popupBoxFiles: []
    });
  };

  componentDidMount() {
    this.props.setDrawerOpen(false);
    this.getData();
  }

  render() {

    const {classes} = this.props;

    const columns = [
      { name: "SRNo", title: "SR#" },
      { name: "sectionLabel", title: "Section" },
      { name: "label", title: "Title" },
      { name: "startDate", title: "Start\xa0Date" },
      { name: "endDate", title: "End\xa0Date" },
      // { name: "instruction", title: "Instruction" },
      // { name: "fileDownload", title: "Assignment" },
      // { name: "solutionFileDownload", title: "Solution" },
      // { name: "helpingMaterialFileDownload", title: "Helping Material" },
      { name: "totalMarks", title: "Total\xa0Marks" },
      // { name: "answerSheet", title: "Answer\xa0Sheet" },
      // { name: "answerSheetDownload", title: "Download Answer\xa0Sheet" },
      { name: "obtainedMarks", title: "Obtained Marks"},
      { name: "assignmentPercentage", title: "Percentage"},
      { name: "uploadedOn", title: "Uploaded\xa0On" },
      { name: "gradedAssignmentUrl", title: "Graded Assignment"},
      { name: "remarks", title: "Teacher\xa0Remarks" }
    ];

    return (
      <Fragment>
        <LoginMenu
          reload={this.state.isReload}
          open={this.state.isLoginMenu}
          handleClose={() => this.setState({ isLoginMenu: false })}
        />
        <div
          style={{
            padding: 20,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography
              style={{
                color: "#1d5f98",
                fontWeight: 600,
                textTransform: "capitalize",
              }}
              variant="h5"
            >
              <Tooltip title="Back">
                <IconButton onClick={() =>   window.location = "#/dashboard"} size="large">
                  <ArrowBackIcon fontSize="small" color="primary" />
                </IconButton>
              </Tooltip>
              Graded Assignments
            </Typography>
            {/* 
              <img alt="" src={ExcelIcon} onClick={() => this.downloadExcelData()} style={{
                  height: 30, width: 32,
                  cursor: `${this.state.isDownloadExcel ? 'wait' : 'pointer'}`,
               }}
              /> 
            */}
            <div style={{ float: "right" }}>
              {/* <Hidden xsUp={true}> */}
              {/* <Tooltip title="Search Bar">
                    <IconButton
                        onClick={this.handleToggleSearchBar}
                    >
                        <FilterIcon fontSize="default" color="primary"/>
                    </IconButton>
                </Tooltip> */}
              {/* </Hidden> */}
              <Tooltip title="Table Filter">
                <IconButton
                  style={{ marginLeft: "-10px" }}
                  onClick={this.handleToggleTableFilter}
                  size="large">
                  <FilterIcon fontSize="default" color="primary" />
                </IconButton>
              </Tooltip>
            </div>
          </div>
          <Divider
            style={{
              backgroundColor: "rgb(58, 127, 187)",
              opacity: "0.3",
            }}
          />
          {this.state.showSearchBar ? (
            <F300FormFilter
              isLoading={this.state.isLoading}
              handleDateChange={this.handleDateChange}
              onClearFilters={this.onClearFilters}
              values={this.state}
              getDataByStatus={(status) => this.getData(status)}
              onHandleChange={(e) => this.onHandleChange(e)}
            />
          ) : (
            <br />
          )}
          {this.state.admissionData ? (
            <F300FormTable
              data={this.state.admissionData}
              columns={columns}
              showFilter={this.state.showTableFilter}
            />
          ) : (
            <Grid container justifyContent="center" alignItems="center">
              <CircularProgress />
            </Grid>
          )}
          <HelpingMaterialPopup
            open={this.state.popupBoxOpen}
            handleClose={this.handleClose}
            classes={classes}
            filesName={this.state.popupBoxFiles}
            downloadFile={this.downloadFile}
          />
          <CustomizedSnackbar
            isOpen={this.state.isOpenSnackbar}
            message={this.state.snackbarMessage}
            severity={this.state.snackbarSeverity}
            handleCloseSnackbar={() => this.handleCloseSnackbar()}
          />
        </div>
      </Fragment>
    );
  }
}
export default withStyles(styles)(F300Form);
